<template>
    <div class="flex flex-col gap-1 items-end shrink-0 text-sm leading-4">
        <div class="text-right" :class="isListPrice ? 'text-sale' : 'text-neutral'">
            <span v-if="displayFrom">{{ $t('search.input.priceFrom') }}</span> {{ getFormattedPrice(unitPrice) }}
            <span v-if="isListPrice" class="block line-through font-normal text-base-content-subtle h-5">
                {{ $t('search.input.priceInstead') }} {{ getFormattedPrice(price?.listPrice?.price) }}
            </span>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { Schemas } from '#shopware'

const props = defineProps<{
    product: Schemas['Product']
}>()

const productRef = computed(() => props.product)
const { getFormattedPrice } = usePrice()
const { unitPrice, isListPrice, displayFrom, price } = useProductPriceCustom(productRef)
</script>
